import React from 'react';
import logoFace from '../../assets/logo-face.png';

// Branded loading spinner: the MOGGED face mark inside a rotating aurum
// arc. Replaces text-only "ANALYZING" indicators across loading states
// (scan analysis, archive fetches, deck loads).
//
// Props:
//   size       outer diameter in px (default 96)
//   label      optional caption under the spinner (omitted by default —
//              the mark carries the brand; no busy-text needed)
//   className  extra classes on the wrapper
const LogoSpinner = ({ size = 96, label, className = '' }) => {
  const stroke = 2;
  const r = (size - stroke) / 2;
  const circumference = 2 * Math.PI * r;
  return (
    <div
      role="status"
      aria-label={label || 'Loading'}
      data-testid="logo-spinner"
      className={['flex flex-col items-center justify-center gap-4', className]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="relative" style={{ width: size, height: size }}>
        <img
          src={logoFace}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 m-auto object-contain mix-blend-screen motion-safe:animate-mesh-pulse"
          style={{ width: size * 0.62, height: size * 0.62 }}
        />
        {/* faint full track + rotating aurum arc */}
        <svg
          aria-hidden="true"
          className="absolute inset-0 motion-safe:animate-spin"
          style={{ animationDuration: '1.4s' }}
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          fill="none"
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke="rgba(255,255,255,0.10)"
            strokeWidth={stroke}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke="#C9A45C"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={`${circumference * 0.28} ${circumference * 0.72}`}
            style={{ filter: 'drop-shadow(0 0 6px rgba(201,164,92,0.55))' }}
          />
        </svg>
      </div>
      {label && (
        <span className="font-display uppercase tracking-[0.22em] text-[11px] text-bone-dim">
          {label}
        </span>
      )}
    </div>
  );
};

export default LogoSpinner;
